import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { apiUrl, wc_categories } from "../../../config/config";
import { omitEmptyValuesProp } from "../../../utils";

export const useGetCategories = (params = {}) => {
  const categories_params = omitEmptyValuesProp({
    ...params,
  });
  const fn = async () => {
    const { data } = await axios.get(`${apiUrl}/${wc_categories}`, { params: categories_params });

    return data;
  };

  return useQuery([wc_categories, categories_params], fn);
};
